import React, { useEffect, useState } from "react";
import contactImg from "./assets/contact-us-img.png";
import "./styles/contactus.css";
import { Form, Input, Button, Row, Col, Select, notification, message } from "antd";
import { referralOptions } from "../landingpage/data/pdvLandingPageData";
import axios from "axios";
import { MuiTelInput } from "mui-tel-input";
import send_email_public from "../../service/network/WithoutUHXURLMapper";
import IntentType from "../../intentexecutor/utils/IntentType";
import { executeIntent } from "../utils/IntentExecutor";
import ErrorNotificationComponent from "../../components/generic/error/ErrorNotificationComponent";
import HeaderComponent from "../landingpage/header/HeaderComponent";
import FooterComponent from "../landingpage/footer/FooterComponent";
import { Helmet } from "react-helmet-async";

const { Option } = Select;

const ContactUs = () => {
  const [form] = Form.useForm();
  const [referralVsible, setReferralVsible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emailId, setEmailId] = useState({ to: "", cc: [] });

  const fetchEmailId = async () => {
    const payload = {
      configurationKey: ["niramaya.admin.emails"],
    };
    try {
      const response = await executeIntent(
        IntentType.GET_PUBLIC_CONFIGURATION,
        payload
      );

      const configValue = response[0]?.configurationValue;

      const emailIds = JSON.parse(configValue || "[]");
      if (Array.isArray(emailIds) && emailIds.length > 0) {
        setEmailId({
          to: emailIds[0],
          cc: emailIds.slice(1),
        });
      }
    } catch (error) {
      ErrorNotificationComponent(error);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const { to, cc } = emailId;
      const formValues = Object.entries(values)
        .map(([key, value]) => `${key}: ${value}`)
        .join("\n");

      const payload = {
        subject: "PDV Contact Us Form Response",
        body: formValues,
        to: to.length > 0 ? to : "",
        ccList: cc,
      };

      const response = await axios.post(
        send_email_public.send_email_public,
        payload
      );
      if (response.status) {
        form.resetFields()
        notification.success({
          message: "Your message has been sent successfully.",
          placement: "bottomRight",
        });
      } else {
        notification.error({
          message: "Failed to send message. Try again later.",
          placement: "bottomRight",
        });
      }
    } catch (error) {
      ErrorNotificationComponent(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmailId();
  }, []);

  const handleReferralChange = (value) => {
    if (value === "Others") {
      setReferralVsible(true);
    } else {
      setReferralVsible(false);
    }
  };
  const inputFieldSyle = {
    "& .MuiOutlinedInput-root": {
      color: "#000",
      paddingTop: "8px",
      marginTop: "-0.3em",
      borderWidth: "0px",
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "var(--main-theme-color) !important",
          borderWidth: "1px",
        },
      },
    },
    "& .MuiInputLabel-outlined": {
      "&.Mui-focused": {
        color: "var(--main-theme-color) !important",
      },
    },
  };
  return (
    <>
    <Helmet>
      <title>Have Questions? Contact Patient Data Vault Today!</title>
      <meta name="description" content="Have questions about PDV? Contact our team today for support, inquiries, or a demo of our HIPAA-compliant hospice volunteer management system."/>
      <meta property="Have Questions? Contact Patient Data Vault Today!" content="Have Questions? Contact Patient Data Vault Today!"/>
    </Helmet>
    <section className="pdv-contact-page ">
       <HeaderComponent />

      <div className="pdv-contact-form-container  ">
        <Row gutter={[16, 16]}>
          <Col xs={24} md={24} lg={16}>
            <h2 className="pdv-contact-form-heading">
              Please feel free to contact us.
            </h2>
            <Form
              form={form}
              name="contact"
              layout="vertical"
              autoComplete="off"
              onFinish={handleSubmit}
            >
              <Row gutter={8}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    className="contact-label"
                    label="First Name"
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your first name",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your first name"
                      className="contact-input-box"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    className="contact-label"
                    label="Last Name"
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your last name",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your last name"
                      className="contact-input-box"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    className="contact-label"
                    label="Email Address"
                    name="email"
                    rules={[
                      {
                        required: true,
                        type: "email",
                        message: "Please enter a valid email",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your email"
                      className="contact-input-box"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    className="contact-label"
                    label="Mobile Number"
                    name="mobileNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your mobile number",
                      },
                    ]}
                  >
                    <MuiTelInput
                      className="contact-us-phone-number"
                      fullWidth
                      placeholder="Enter your mobile number"
                      forceCallingCode
                      defaultCountry="US"
                      sx={inputFieldSyle}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={8}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    className="contact-label"
                    label="Hospice Name"
                    name="hospiceName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your hospice name",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your hospice name"
                      className="contact-input-box"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    className="contact-label"
                    label="Hospice City"
                    name="hospiceCity"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your hospice city",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter your hospice city"
                      className="contact-input-box"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={8}>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    className="contact-label"
                    label="Service you're looking for"
                    name="service"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the service you are looking for",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter the service you're looking for"
                      className="contact-input-box"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                  <Form.Item
                    className="contact-label"
                    label="How did you hear about us"
                    name="referral"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Any One",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please Select"
                      onChange={handleReferralChange}
                    >
                      {referralOptions.map((option) => (
                        <Option key={option.value} value={option.value}>
                          {option.value}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              {referralVsible && (
                <Form.Item
                  className="contact-label"
                  label="Other (Specify)"
                  name="otherReferral"
                  rules={[
                    {
                      required: referralVsible,
                      message: "Please specify how you heard about us",
                    },
                  ]}
                >
                  <Input
                    placeholder="Please Specify"
                    className="contact-input-box"
                  />
                </Form.Item>
              )}
              <Form.Item
                className="contact-label"
                label="Message"
                name="message"
                rules={[{ message: "Please write your message" }]}
              >
                <Input.TextArea
                  placeholder="Write your message here"
                  className="contact-input-box contact-text-area"
                  rows={4}
                />
              </Form.Item>

              <Form.Item className="pdv-contactus-button">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="contactus-button"
                  loading={loading}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Col>

          <Col xs={24} md={8}>
            <img
              src={contactImg}
              className="pdv-contact-image"
              alt=" pdv to schedule a demo"
              style={{ borderRadius: "12px" }}
            />
          </Col>
        </Row>
      </div>
     <FooterComponent />
    </section>
    </>
  );
};

export default ContactUs;
